import MediumBanner from 'components/LandingPage/MediumBaner/MediumBanner';
import React, { FC } from 'react';
import { Block, MediumBlockGroupType } from 'store/landing/types';
import cn from 'classnames';
import ProductCarousel from 'components/Common/ProductCarousel/ProductCarousel';
import { useSelector } from 'react-redux';
import OpIcon from 'components/Common/op-ui-wrappers/OpIcon/OpIcon';
import getLandingPageData from 'store/landing/selector/getLandingPageData';
import styles from './MediumBlockGroupCarousel.module.scss';
import RectangularMediumBanner from '../../MediumBaner/RectangularMediumBanner';
import RoundedRectangularMediumBanner from '../../MediumBaner/RoundedRectangularMediumBanner';

const mediumBannerTypeComponents: Record<MediumBlockGroupType, React.FC<any>> = {
  default: MediumBanner,
  portrait: RectangularMediumBanner,
  'portrait-grid': RoundedRectangularMediumBanner,
  'portrait-rounded': RoundedRectangularMediumBanner,
} as const;

interface MediumBlockGroupCarousel {
  blocks: Block[];
  title?: string;
  variant?: MediumBlockGroupType;
  seeAllUrl?: string;
  seeAllLabel?: string;
}

const MediumBlockGroupCarousel: FC<MediumBlockGroupCarousel> = ({ blocks, title, variant, seeAllUrl, seeAllLabel }) => {
  const theme = useSelector(getLandingPageData)?.theme;
  const scrollable = blocks.length > 4;

  if (!blocks.length) {
    return null;
  }

  return (
    <div
      className={cn(styles[`theme-${theme}`], {
        [styles.container]: theme !== 'shopify',
      })}
    >
      {title && (
        <div className={styles.heading}>
          {title && <span className={styles.title}>{title}</span>}
          {seeAllLabel && (
            <a href={seeAllUrl} className={styles.seeAllLabel}>
              {seeAllLabel}
              <OpIcon icon="carret-right" />
            </a>
          )}
        </div>
      )}

      <ProductCarousel theme={theme} scrollable={scrollable} type={variant}>
        {blocks.map((block: Block) => {
          const MediumBannerComponent = mediumBannerTypeComponents[variant || 'default'];

          return (
            <MediumBannerComponent
              imageUrl={block.imageUrl || ''}
              imageUrlMobile={block.imageUrlMobile || ''}
              referenceBackgroundColor={block.referenceBackgroundColor || ''}
              referenceBorderColor={block.referenceBorderColor || ''}
              referenceLabel={block.referenceLabel || block.title || ''}
              referenceLabelColor={block.referenceLabelColor || ''}
              referenceUrl={block.referenceUrl || ''}
              mode="carousel"
              priceFormatted={block.priceFormatted}
            />
          );
        })}
      </ProductCarousel>
    </div>
  );
};

export default MediumBlockGroupCarousel;
